import { PasswordNeedsChangeCheck } from "@/components/authentication/PasswordNeedsChangeCheck";
import { Loading } from "@/components/overlays/Loading";
import { store } from "@/store";
import { supabaseApi, useGetAssuranceLevelQuery, useGetCurrentUserQuery } from "@/store/services/supabase";
import { useSession, useSupabaseClient } from "@supabase/auth-helpers-react";
import { useRouter } from "next/router";
import { useEffect } from "react";
export const AuthCheck = ({
  children
}: {
  children: JSX.Element;
}) => {
  const router = useRouter();
  const session = useSession();
  const supabase = useSupabaseClient();
  const {
    data: assuranceLevel,
    refetch: refetchAssuranceLevel
  } = useGetAssuranceLevelQuery();
  const {
    data: user
  } = useGetCurrentUserQuery();
  useEffect(() => {
    refetchAssuranceLevel().then(({
      data
    }) => {
      if (!data || !data.hasVerifiedMFA) {
        router.push("/login");
      }
    });
  }, []);
  const forceRefetchCurrentUser = async () => {
    const {
      data
    } = await supabase.auth.getSession();
    // comparing session vs cached data
    if (user?.id !== data.session?.user.id) {
      store.dispatch(supabaseApi.endpoints.getCurrentUser.initiate(undefined, {
        forceRefetch: true
      }));
    }
  };
  useEffect(() => {
    if (!session) {
      router.push("/login");
    }
    const {
      data: authListener
    } = supabase.auth.onAuthStateChange(event => {
      console.log(`Supabase auth event: ${event}`);
      if (event === "INITIAL_SESSION") {
        forceRefetchCurrentUser();
      } else if (event === "SIGNED_OUT") {
        localStorage.clear();
        sessionStorage.clear();
      }
    });
    return () => {
      authListener.subscription.unsubscribe();
    };
  }, [session]);
  if (!session || !assuranceLevel || !assuranceLevel.hasVerifiedMFA) {
    return <Loading />;
  }
  return <PasswordNeedsChangeCheck data-sentry-element="PasswordNeedsChangeCheck" data-sentry-component="AuthCheck" data-sentry-source-file="AuthCheck.tsx">{children}</PasswordNeedsChangeCheck>;
};